import React from 'react';
import {
    LayoutGrid,
    DollarSign,
    Users,
    BarChart3,
    Settings as SettingsIcon,
    LogOut,
    ArrowLeftRight
} from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../context/LanguageContext';

export default function AccountantSidebar() {
    const navigate = useNavigate();
    const { t } = useLanguage();

    const menuItems = [
        { nameKey: 'dashboard', icon: LayoutGrid, path: '/accountant/dashboard' },
        { nameKey: 'feeCollection', icon: DollarSign, path: '/accountant/fees' },
        { nameKey: 'students', icon: Users, path: '/accountant/students' },
        { nameKey: 'reports', icon: BarChart3, path: '/accountant/reports' },
        { nameKey: 'settings', icon: SettingsIcon, path: '/accountant/settings' },
    ];

    return (
        <aside className="w-[280px] h-screen bg-white border-r border-gray-100 flex flex-col font-sans shrink-0 overflow-y-auto overflow-x-hidden">
            {/* Header / Logo */}
            <div className="h-[72px] flex items-center justify-between px-6 border-b border-gray-100 shrink-0 sticky top-0 bg-white z-10">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-blue-500 rounded-xl flex items-center justify-center text-white shadow-lg shadow-blue-100">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                        </svg>
                    </div>
                    <span className="text-[22px] font-black tracking-tighter text-[#111827]">School-OS</span>
                </div>
            </div>

            {/* Navigation Links */}
            <nav className="flex-1 px-4 py-6 space-y-1">
                {menuItems.map((item, index) => {
                    const Icon = item.icon;
                    return (
                        <NavLink
                            key={index}
                            to={item.path}
                            className="w-full block"
                        >
                            {({ isActive }) => (
                                <div className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${isActive
                                    ? 'bg-blue-50 text-blue-500 font-bold'
                                    : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900 font-medium'
                                    }`}>
                                    <div className="w-6 h-6 flex shrink-0 items-center justify-center">
                                        <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                                    </div>
                                    <span className="text-[15px]">{t(item.nameKey)}</span>
                                </div>
                            )}
                        </NavLink>
                    );
                })}
            </nav>

            {/* Bottom Footer Area */}
            <div className="px-4 pb-6 pt-4 border-t border-gray-50 space-y-4">
                {/* User Card */}
                <div className="flex items-center justify-between p-3 rounded-xl border border-gray-100 bg-white shadow-sm hover:border-gray-200 transition-all group">
                    <div className="flex items-center gap-3 overflow-hidden">
                        <div className="w-9 h-9 rounded-lg bg-blue-600 text-white flex items-center justify-center font-black text-sm shadow-md shadow-blue-100 shrink-0 uppercase">
                            A
                        </div>
                        <div className="min-w-0">
                            <span className="block text-[14px] font-bold text-gray-800 leading-none mb-1 truncate">Accountant User</span>
                            <span className="block text-[12px] text-gray-400 font-medium font-sans">Finance Dept</span>
                        </div>
                    </div>
                    <button
                        onClick={() => navigate('/login')}
                        className="p-2 hover:bg-red-50 text-gray-400 hover:text-red-500 rounded-lg transition-colors"
                        title={t('logout')}
                    >
                        <LogOut size={16} />
                    </button>
                </div>
                {/* Copyright */}
                <div className="pt-2 text-center">
                    <p className="text-[11px] text-gray-400 font-medium font-sans">© 2026 nerdOS | All rights reserved</p>
                </div>
            </div>
        </aside>
    );
}
